// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Layout Styles
 * Styles for the main layout and navigation components
 */

/* Page Layout */
.page-layout {
  min-height: 100vh;
  background-color: var(--color-gray-50);
}

.dark .page-layout {
  background-color: var(--color-slate-900);
}

.page-main {
  padding-top: 4rem; /* Account for fixed navbar */
}

.page-container {
  max-width: 106rem;
  margin: 0 auto;
  padding: 2rem 1rem;
}

@media (min-width: 640px) {
  .page-container {
    padding: 2rem 1.5rem;
  }
}

@media (min-width: 1024px) {
  .page-container {
    padding: 2rem 2rem;
  }
}

/* Alert Popups Container */
.alert-popups-container {
  position: fixed;
  top: 5rem;
  right: 1rem;
  z-index: 50;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-width: 24rem;
  width: 100%;
}

/* Navbar */
.navbar {
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: var(--shadow-md);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  backdrop-filter: blur(8px);
}

.dark .navbar {
  background-color: rgba(30, 41, 59, 0.95);
}

.navbar__container {
  /*max-width: 104rem;*/
  margin: 0 auto;
  padding: 0 1rem;
  background: #1e293b;
}

@media (min-width: 640px) {
  .navbar__container {
    padding: 0 1.5rem;
  }
}

@media (min-width: 1024px) {
  .navbar__container {
    padding: 0 2rem;
  }
}

.navbar__content {
  display: flex;
  justify-content: space-between;
  height: 4rem;
}

/* Logo and Brand */
.navbar__brand {
  display: flex;
  align-items: center;
}

.navbar__brand-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
}

.navbar__logo {
  width: 3rem;
  border-radius: var(--radius-lg);
  object-fit: contain;
}

.navbar__title {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  color: #ffffff;
}

/* Desktop Navigation */
.navbar__nav {
  display: none;
  align-items: center;
  gap: 0.25rem;
}

@media (min-width: 768px) {
  .navbar__nav {
    display: flex;
  }
}

.navbar__link {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  border-radius: var(--radius-lg);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  transition: var(--transition-base);
  text-decoration: none;
  background: none;
  border: none;
  cursor: pointer;
}

.navbar__link svg {
  width: 1.25rem;
  height: 1.25rem;
}

.navbar__link--active {
  background-color: var(--color-primary-50);
  color: var(--color-primary-700);
}

.dark .navbar__link--active {
  background-color: rgba(37, 99, 235, 0.2);
  color: var(--color-primary-400);
}

.navbar__link:not(.navbar__link--active) {
  color: #ffffff;
}

.dark .navbar__link:not(.navbar__link--active) {
  color: var(--color-gray-300);
}

.navbar__link:not(.navbar__link--active):hover {
  background-color: var(--color-gray-100);
}

.dark .navbar__link:not(.navbar__link--active):hover {
  background-color: var(--color-slate-700);
}

.navbar__badge {
  position: absolute;
  top: -0.25rem;
  right: -0.25rem;
  background-color: var(--color-danger-500);
  color: #ffffff;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-bold);
  border-radius: 9999px;
  height: 1.25rem;
  width: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Right Side Actions */
.navbar__actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.navbar__theme-toggle {
  padding: 0.5rem;
  border-radius: var(--radius-lg);
  color: var(--color-gray-700);
  background: none;
  border: none;
  cursor: pointer;
  transition: var(--transition-base);
}

.dark .navbar__theme-toggle {
  color: var(--color-gray-300);
}

.navbar__theme-toggle:hover {
  background-color: var(--color-gray-100);
}

.dark .navbar__theme-toggle:hover {
  background-color: var(--color-slate-700);
}

.navbar__theme-toggle svg {
  width: 1.25rem;
  height: 1.25rem;
}

/* User Menu */
.navbar__user-menu {
  position: relative;
}

.navbar__user-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  border-radius: var(--radius-lg);
  background: none;
  border: none;
  cursor: pointer;
  transition: var(--transition-base);
}

.navbar__user-button:hover {
  background-color: var(--color-gray-100);
}

.dark .navbar__user-button:hover {
  background-color: var(--color-slate-700);
}

.navbar__user-avatar {
  width: 2rem;
  height: 2rem;
  background-color: var(--color-primary-600);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-sm);
}

.navbar__user-dropdown {
  position: absolute;
  right: 0;
  margin-top: 0.5rem;
  width: 14rem;
  background-color: #ffffff;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  padding: 0.5rem 0;
  border: 1px solid var(--color-gray-200);
}

.dark .navbar__user-dropdown {
  background-color: var(--color-slate-800);
  border-color: var(--color-slate-700);
}

.navbar__user-info {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--color-gray-200);
}

.dark .navbar__user-info {
  border-bottom-color: var(--color-slate-700);
}

.navbar__user-name {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-primary);
}

.navbar__user-email {
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
  margin-top: 0.125rem;
}

.navbar__user-role {
  display: inline-block;
  margin-top: 0.5rem;
  padding: 0.125rem 0.5rem;
  background-color: var(--color-blue-100);
  color: var(--color-blue-700);
  font-size: var(--font-size-xs);
  border-radius: var(--radius-sm);
}

.dark .navbar__user-role {
  background-color: rgba(59, 130, 246, 0.3);
  color: var(--color-blue-400);
}

.navbar__menu-item {
  width: 100%;
  text-align: left;
  padding: 0.5rem 1rem;
  font-size: var(--font-size-sm);
  color: var(--color-gray-700);
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: var(--transition-fast);
  text-decoration: none;
}

.dark .navbar__menu-item {
  color: var(--color-gray-300);
}

.navbar__menu-item:hover {
  background-color: var(--color-gray-100);
}

.dark .navbar__menu-item:hover {
  background-color: var(--color-slate-700);
}

.navbar__menu-item svg {
  width: 1rem;
  height: 1rem;
}

.navbar__logout-button {
  width: 100%;
  text-align: left;
  padding: 0.5rem 1rem;
  font-size: var(--font-size-sm);
  color: var(--color-gray-700);
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: var(--transition-fast);
}

.dark .navbar__logout-button {
  color: var(--color-gray-300);
}

.navbar__logout-button:hover {
  background-color: var(--color-gray-100);
}

.dark .navbar__logout-button:hover {
  background-color: var(--color-slate-700);
}

.navbar__logout-button svg {
  width: 1rem;
  height: 1rem;
}

/* Mobile Menu Button */
.navbar__mobile-toggle {
  display: flex;
  padding: 0.5rem;
  border-radius: var(--radius-lg);
  color: var(--color-gray-700);
  background: none;
  border: none;
  cursor: pointer;
  transition: var(--transition-fast);
}

.dark .navbar__mobile-toggle {
  color: var(--color-gray-300);
}

.navbar__mobile-toggle:hover {
  background-color: var(--color-gray-100);
}

.dark .navbar__mobile-toggle:hover {
  background-color: var(--color-slate-700);
}

.navbar__mobile-toggle svg {
  width: 1.5rem;
  height: 1.5rem;
}

@media (min-width: 768px) {
  .navbar__mobile-toggle {
    display: none;
  }
}

/* Mobile Menu */
.navbar__mobile-menu {
  border-top: 1px solid var(--color-gray-200);
}

.dark .navbar__mobile-menu {
  border-top-color: var(--color-slate-700);
}

.navbar__mobile-menu-content {
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

@media (min-width: 768px) {
  .navbar__mobile-menu {
    display: none;
  }
}

.navbar__mobile-link {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0.75rem;
  border-radius: var(--radius-lg);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  text-decoration: none;
  background: none;
  border: none;
  cursor: pointer;
  width: 100%;
  text-align: left;
}

.navbar__mobile-link svg {
  width: 1.25rem;
  height: 1.25rem;
}

.navbar__mobile-link--active {
  background-color: var(--color-primary-50);
  color: var(--color-primary-700);
}

.dark .navbar__mobile-link--active {
  background-color: rgba(37, 99, 235, 0.2);
  color: var(--color-primary-400);
}

.navbar__mobile-link:not(.navbar__mobile-link--active) {
  color: var(--color-gray-700);
}

.dark .navbar__mobile-link:not(.navbar__mobile-link--active) {
  color: var(--color-gray-300);
}

.navbar__mobile-link:not(.navbar__mobile-link--active):hover {
  background-color: var(--color-gray-100);
}

.dark .navbar__mobile-link:not(.navbar__mobile-link--active):hover {
  background-color: var(--color-slate-700);
}

.navbar__mobile-badge {
  margin-left: auto;
  background-color: var(--color-danger-500);
  color: #ffffff;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-bold);
  border-radius: 9999px;
  height: 1.25rem;
  width: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

`, "",{"version":3,"sources":["webpack://./src/styles/layout.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,gBAAgB;AAChB;EACE,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB,EAAE,6BAA6B;AAClD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,WAAW;AACb;;AAEA,WAAW;AACX;EACE,2CAA2C;EAC3C,4BAA4B;EAC5B,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;EACxC,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,+BAA+B;EAC/B,8BAA8B;EAC9B,sCAAsC;EACtC,kCAAkC;EAClC,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,yCAAyC;EACzC,cAAc;EACd,8BAA8B;EAC9B,oCAAoC;EACpC,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;EACxB,uCAAuC;EACvC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,eAAe;EACf,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,gBAAgB;AAChB;EACE,2CAA2C;AAC7C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,gCAAgC;EAChC,sCAAsC;EACtC,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,cAAc;EACd,8BAA8B;EAC9B,oCAAoC;EACpC,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":["/**\n * Layout Styles\n * Styles for the main layout and navigation components\n */\n\n/* Page Layout */\n.page-layout {\n  min-height: 100vh;\n  background-color: var(--color-gray-50);\n}\n\n.dark .page-layout {\n  background-color: var(--color-slate-900);\n}\n\n.page-main {\n  padding-top: 4rem; /* Account for fixed navbar */\n}\n\n.page-container {\n  max-width: 106rem;\n  margin: 0 auto;\n  padding: 2rem 1rem;\n}\n\n@media (min-width: 640px) {\n  .page-container {\n    padding: 2rem 1.5rem;\n  }\n}\n\n@media (min-width: 1024px) {\n  .page-container {\n    padding: 2rem 2rem;\n  }\n}\n\n/* Alert Popups Container */\n.alert-popups-container {\n  position: fixed;\n  top: 5rem;\n  right: 1rem;\n  z-index: 50;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  max-width: 24rem;\n  width: 100%;\n}\n\n/* Navbar */\n.navbar {\n  background-color: rgba(255, 255, 255, 0.95);\n  box-shadow: var(--shadow-md);\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 50;\n  backdrop-filter: blur(8px);\n}\n\n.dark .navbar {\n  background-color: rgba(30, 41, 59, 0.95);\n}\n\n.navbar__container {\n  /*max-width: 104rem;*/\n  margin: 0 auto;\n  padding: 0 1rem;\n  background: #1e293b;\n}\n\n@media (min-width: 640px) {\n  .navbar__container {\n    padding: 0 1.5rem;\n  }\n}\n\n@media (min-width: 1024px) {\n  .navbar__container {\n    padding: 0 2rem;\n  }\n}\n\n.navbar__content {\n  display: flex;\n  justify-content: space-between;\n  height: 4rem;\n}\n\n/* Logo and Brand */\n.navbar__brand {\n  display: flex;\n  align-items: center;\n}\n\n.navbar__brand-link {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  text-decoration: none;\n}\n\n.navbar__logo {\n  width: 3rem;\n  border-radius: var(--radius-lg);\n  object-fit: contain;\n}\n\n.navbar__title {\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-semibold);\n  color: #ffffff;\n}\n\n/* Desktop Navigation */\n.navbar__nav {\n  display: none;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n@media (min-width: 768px) {\n  .navbar__nav {\n    display: flex;\n  }\n}\n\n.navbar__link {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  border-radius: var(--radius-lg);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  transition: var(--transition-base);\n  text-decoration: none;\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n.navbar__link svg {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n.navbar__link--active {\n  background-color: var(--color-primary-50);\n  color: var(--color-primary-700);\n}\n\n.dark .navbar__link--active {\n  background-color: rgba(37, 99, 235, 0.2);\n  color: var(--color-primary-400);\n}\n\n.navbar__link:not(.navbar__link--active) {\n  color: #ffffff;\n}\n\n.dark .navbar__link:not(.navbar__link--active) {\n  color: var(--color-gray-300);\n}\n\n.navbar__link:not(.navbar__link--active):hover {\n  background-color: var(--color-gray-100);\n}\n\n.dark .navbar__link:not(.navbar__link--active):hover {\n  background-color: var(--color-slate-700);\n}\n\n.navbar__badge {\n  position: absolute;\n  top: -0.25rem;\n  right: -0.25rem;\n  background-color: var(--color-danger-500);\n  color: #ffffff;\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-bold);\n  border-radius: 9999px;\n  height: 1.25rem;\n  width: 1.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Right Side Actions */\n.navbar__actions {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.navbar__theme-toggle {\n  padding: 0.5rem;\n  border-radius: var(--radius-lg);\n  color: var(--color-gray-700);\n  background: none;\n  border: none;\n  cursor: pointer;\n  transition: var(--transition-base);\n}\n\n.dark .navbar__theme-toggle {\n  color: var(--color-gray-300);\n}\n\n.navbar__theme-toggle:hover {\n  background-color: var(--color-gray-100);\n}\n\n.dark .navbar__theme-toggle:hover {\n  background-color: var(--color-slate-700);\n}\n\n.navbar__theme-toggle svg {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n/* User Menu */\n.navbar__user-menu {\n  position: relative;\n}\n\n.navbar__user-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem;\n  border-radius: var(--radius-lg);\n  background: none;\n  border: none;\n  cursor: pointer;\n  transition: var(--transition-base);\n}\n\n.navbar__user-button:hover {\n  background-color: var(--color-gray-100);\n}\n\n.dark .navbar__user-button:hover {\n  background-color: var(--color-slate-700);\n}\n\n.navbar__user-avatar {\n  width: 2rem;\n  height: 2rem;\n  background-color: var(--color-primary-600);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #ffffff;\n  font-weight: var(--font-weight-medium);\n  font-size: var(--font-size-sm);\n}\n\n.navbar__user-dropdown {\n  position: absolute;\n  right: 0;\n  margin-top: 0.5rem;\n  width: 14rem;\n  background-color: #ffffff;\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-lg);\n  padding: 0.5rem 0;\n  border: 1px solid var(--color-gray-200);\n}\n\n.dark .navbar__user-dropdown {\n  background-color: var(--color-slate-800);\n  border-color: var(--color-slate-700);\n}\n\n.navbar__user-info {\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid var(--color-gray-200);\n}\n\n.dark .navbar__user-info {\n  border-bottom-color: var(--color-slate-700);\n}\n\n.navbar__user-name {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  color: var(--color-text-primary);\n}\n\n.navbar__user-email {\n  font-size: var(--font-size-xs);\n  color: var(--color-text-secondary);\n  margin-top: 0.125rem;\n}\n\n.navbar__user-role {\n  display: inline-block;\n  margin-top: 0.5rem;\n  padding: 0.125rem 0.5rem;\n  background-color: var(--color-blue-100);\n  color: var(--color-blue-700);\n  font-size: var(--font-size-xs);\n  border-radius: var(--radius-sm);\n}\n\n.dark .navbar__user-role {\n  background-color: rgba(59, 130, 246, 0.3);\n  color: var(--color-blue-400);\n}\n\n.navbar__menu-item {\n  width: 100%;\n  text-align: left;\n  padding: 0.5rem 1rem;\n  font-size: var(--font-size-sm);\n  color: var(--color-gray-700);\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  transition: var(--transition-fast);\n  text-decoration: none;\n}\n\n.dark .navbar__menu-item {\n  color: var(--color-gray-300);\n}\n\n.navbar__menu-item:hover {\n  background-color: var(--color-gray-100);\n}\n\n.dark .navbar__menu-item:hover {\n  background-color: var(--color-slate-700);\n}\n\n.navbar__menu-item svg {\n  width: 1rem;\n  height: 1rem;\n}\n\n.navbar__logout-button {\n  width: 100%;\n  text-align: left;\n  padding: 0.5rem 1rem;\n  font-size: var(--font-size-sm);\n  color: var(--color-gray-700);\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  transition: var(--transition-fast);\n}\n\n.dark .navbar__logout-button {\n  color: var(--color-gray-300);\n}\n\n.navbar__logout-button:hover {\n  background-color: var(--color-gray-100);\n}\n\n.dark .navbar__logout-button:hover {\n  background-color: var(--color-slate-700);\n}\n\n.navbar__logout-button svg {\n  width: 1rem;\n  height: 1rem;\n}\n\n/* Mobile Menu Button */\n.navbar__mobile-toggle {\n  display: flex;\n  padding: 0.5rem;\n  border-radius: var(--radius-lg);\n  color: var(--color-gray-700);\n  background: none;\n  border: none;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.dark .navbar__mobile-toggle {\n  color: var(--color-gray-300);\n}\n\n.navbar__mobile-toggle:hover {\n  background-color: var(--color-gray-100);\n}\n\n.dark .navbar__mobile-toggle:hover {\n  background-color: var(--color-slate-700);\n}\n\n.navbar__mobile-toggle svg {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n\n@media (min-width: 768px) {\n  .navbar__mobile-toggle {\n    display: none;\n  }\n}\n\n/* Mobile Menu */\n.navbar__mobile-menu {\n  border-top: 1px solid var(--color-gray-200);\n}\n\n.dark .navbar__mobile-menu {\n  border-top-color: var(--color-slate-700);\n}\n\n.navbar__mobile-menu-content {\n  padding: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n@media (min-width: 768px) {\n  .navbar__mobile-menu {\n    display: none;\n  }\n}\n\n.navbar__mobile-link {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.5rem 0.75rem;\n  border-radius: var(--radius-lg);\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-medium);\n  text-decoration: none;\n  background: none;\n  border: none;\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n}\n\n.navbar__mobile-link svg {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n.navbar__mobile-link--active {\n  background-color: var(--color-primary-50);\n  color: var(--color-primary-700);\n}\n\n.dark .navbar__mobile-link--active {\n  background-color: rgba(37, 99, 235, 0.2);\n  color: var(--color-primary-400);\n}\n\n.navbar__mobile-link:not(.navbar__mobile-link--active) {\n  color: var(--color-gray-700);\n}\n\n.dark .navbar__mobile-link:not(.navbar__mobile-link--active) {\n  color: var(--color-gray-300);\n}\n\n.navbar__mobile-link:not(.navbar__mobile-link--active):hover {\n  background-color: var(--color-gray-100);\n}\n\n.dark .navbar__mobile-link:not(.navbar__mobile-link--active):hover {\n  background-color: var(--color-slate-700);\n}\n\n.navbar__mobile-badge {\n  margin-left: auto;\n  background-color: var(--color-danger-500);\n  color: #ffffff;\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-bold);\n  border-radius: 9999px;\n  height: 1.25rem;\n  width: 1.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
